import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { ConfigProvider } from "antd";
import ca_ES from "antd/lib/locale-provider/ca_ES";
import "moment/locale/ca";
import store from "./store";
import "css-reset-and-normalize/css/reset-and-normalize.css";
import "antd/dist/antd.css";
import "./styles/styles.css";
import App from "./components/App";
import Login from "./components/Login";
import * as rutes from "./routes";
import {
  hasSessionInAnotherTab,
  clearSessionForCurrentTab,
  markSessionForCurrentTab,
  getCurrentTabId,
  refreshSessionHeartbeat
} from "./utils/sessionTab";
import {
  guardarToken,
  eliminarToken,
  obtenirToken
} from "./utils/gestioWebToken";
import {
  MISSATGE_SESSIO_JA_INICIADA,
  MISSATGE_NO_ACCES_RUTA
} from "./constantsFormularis";

import {
  LOCAL_STORAGE_ACTIVE_SESSION_TAB,
  SESSION_STORAGE_RELOAD_FLAG,
  SESSION_STORAGE_TOKEN_BACKUP
} from "./constantsObservacions";

let tabCleanupHandled = false;

const restoreSessionAfterReload = () => {
  const isReloading =
    sessionStorage.getItem(SESSION_STORAGE_RELOAD_FLAG) === "1";
  const backupToken = sessionStorage.getItem(SESSION_STORAGE_TOKEN_BACKUP);

  if (isReloading && backupToken && !obtenirToken()) {
    guardarToken(backupToken);
    markSessionForCurrentTab();
  }

  sessionStorage.removeItem(SESSION_STORAGE_RELOAD_FLAG);
  sessionStorage.removeItem(SESSION_STORAGE_TOKEN_BACKUP);
};

const cleanupFenocatStorageOnTabClose = () => {
  if (tabCleanupHandled) {
    return;
  }

  tabCleanupHandled = true;

  const activeTabId = localStorage.getItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB);
  const currentTabId = getCurrentTabId();

  if (activeTabId !== currentTabId) {
    return;
  }

  const token = obtenirToken();
  if (token) {
    sessionStorage.setItem(SESSION_STORAGE_TOKEN_BACKUP, token);
  }

  sessionStorage.setItem(SESSION_STORAGE_RELOAD_FLAG, "1");
  clearSessionForCurrentTab();
  eliminarToken();
};

const syncSessionLockForCurrentTab = () => {
  if (!obtenirToken() || hasSessionInAnotherTab()) {
    return;
  }

  markSessionForCurrentTab();
  refreshSessionHeartbeat();
};

const keepSessionLockAlive = () => {
  syncSessionLockForCurrentTab();

  setInterval(() => {
    if (obtenirToken()) {
      refreshSessionHeartbeat();
    }
  }, 30000);

  window.addEventListener("focus", refreshSessionHeartbeat);
  window.addEventListener("pageshow", refreshSessionHeartbeat);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      refreshSessionHeartbeat();
    }
  });
};

restoreSessionAfterReload();
keepSessionLockAlive();
window.addEventListener("beforeunload", cleanupFenocatStorageOnTabClose);
window.addEventListener("pagehide", cleanupFenocatStorageOnTabClose);

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={ca_ES}>
      <HashRouter basename={"/"}>
        <Switch>
          <Route
            exact
            path={rutes.rutaLogin}
            render={props => (
              <Login
                {...props}
                authMessage={
                  hasSessionInAnotherTab() ? MISSATGE_SESSIO_JA_INICIADA : null
                }
              />
            )}
          />
          <Route
            path={rutes.rutaArrel}
            render={props =>
              hasSessionInAnotherTab() ? (
                <Redirect
                  to={{
                    pathname: rutes.rutaLogin,
                    state: {
                      redirectMessage: MISSATGE_NO_ACCES_RUTA
                    }
                  }}
                />
              ) : (
                <App {...props} />
              )
            }
          />
        </Switch>
      </HashRouter>
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);
